<template>
    <section class="h-full flex flex-col p-8">
        <p class="dark:text-gray-200 text-gray-700 text-2xl tracking-widest uppercase">Lista de Usuários</p>
        <div class=" h-full w-4/5 mx-auto py-8">
            <div v-if="usuarios.length === 0 && search !== ''" class="bg-transparent w-full h-20 rounded-lg text-gray-700 dark:text-gray-300 flex">
                <p class="m-auto text-lg">Sem resultados para essa pesquisa</p>
            </div>
            <div v-for="usuario,i in usuarios" :key="i" class="group h-20 w-1/2 bg-gray-100 shadow-sm border mx-auto border-gray-200 dark:border-gray-800 dark:bg-gray-800 hover:bg-indigo-600 dark:hover:bg-indigo-600 transition-all duration-700 rounded-lg cursor-pointer mb-8">
                <span class="text-gray-50 text-xs">
                    {{usuario.nome_fantasia}}
                </span>
                <span class="flex flex-row flex-nowrap items-center p-2 gap-x-4 transition-all duration-300 opacity-100 group-hover:opacity-0 group-hover:hidden">
                    <div class="w-16">
                        <div class="w-16 h-16 bg-indigo-300 rounded-full">
                            <img v-if="usuario.avatar" class="rounded-full " :src="usuario.avatar" alt="">
                            <span v-else class="h-full w-full flex"><p class="m-auto text-2xl text-gray-100">{{usuario.nome[0]}}{{usuario.nome.split(' ')[1][0]}}</p></span>
                        </div>
                    </div>
                    <span class="flex flex-col w-full">
                        <p class="text-lg text-indigo-600 dark:text-indigo-400 truncate w-10/12">{{usuario.nome}}</p>
                        <p class="text-sm capitalize text-gray-500 dark:text-indigo-100">{{usuario.role}}</p>
                    </span>
                    <span class="flex flex-row items-center text-right pr-10">
                        <span class="relative">
                            <div :class="usuario.ativo ? 'bg-gradient-to-b from-green-400 to-green-500' : 'bg-gradient-to-b from-red-500 to-red-600'" class="w-3 h-3 rounded-full"></div>
                            <div :class="usuario.ativo ? 'bg-gradient-to-b from-green-400 to-green-500' : 'bg-gradient-to-b from-red-500 to-red-600'" class="w-3 h-3 rounded-full blur-sm filter absolute"></div>
                        </span>
                    </span>
                </span>
                <span @click="pushToProfile(usuario.id)" class="hidden flex-row flex-wrap items-center p-2 gap-x-4 h-full transition-all duration-700 opacity-0 group-hover:opacity-100 group-hover:flex">
                    <p class="m-auto self-center text-gray-100">Visualizar perfil</p>
                </span>
            </div>
            <div class="flex-1 px-5 flex flex-row items-center gap-x-2">
                <Paginator showChangePage="false" :data="paginationData" type="page" @changePage="changePage"/>
            </div>

        </div>
    </section>
</template>

<script>
import { onMounted, ref } from '@vue/runtime-core'
import { GET_USUARIOS, GET_USUARIOS_FILTER } from '../../mixins/api'
import { useRouter } from 'vue-router'
import Paginator from '@/components/Design/Pagination'
export default {
    name: 'ListaUsuarios',
    components: {
        Paginator
    },
    setup () {
        const usuarios = ref([])
        const search = ref('')

        const loading = ref(true)
        const router = useRouter()

        const getUsers = async () => {
            await GET_USUARIOS().then(response => {
                persistFilter.value = response.config.url
                usuarios.value = response.data.data
                loading.value = false
                paginationData.value = response.data.meta
            }).catch(() => {
            })
        }

        onMounted(async () => {
            await getUsers()
        })

        const paginationData = ref({})
        const persistFilter = ref('')
        const filter = async (_, e, page) => {
            const filters = {
                nome: search.value,
                page: page
            }
            await GET_USUARIOS_FILTER(filters).then(response => {
                persistFilter.value = response.config.url
                usuarios.value = response.data.data
                loading.value = false
                paginationData.value = response.data.meta
            }).catch(() => {
            })
        }

        const changePage = (page) => {
            filter(null, null, page)
            scrollTop()
        }
        const scrollTop = () => {
            var element = document.getElementById('screen')
            element.scrollTo({ top: 0, behavior: 'smooth' })
        }

        const pushToProfile = (id) => {
            router.push({ name: 'Profile', params: { id: id.toString() } })
        }

        return {
            usuarios,
            search,
            pushToProfile,
            paginationData,
            changePage,
            filter
        }
    }
}
</script>

<style>
</style>
